var _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAustralia(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1280,
    height: 640,
    viewBox: "0 0 30240 15120",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,-9 1.735535,-3.6038755 7.0364833,-5.6114082 3.8997116,-0.89008374 8.7743512,2.0026884 3.1273259,2.4939592 3.9049537,8.1087198 0,4 -3.9049537,8.1087198 -3.1273259,2.4939592 -8.7743512,2.0026884 -3.8997116,-0.89008374 -7.0364833,-5.6114082 -1.735535,-3.6038755 0,-9 ",
    id: "Star7"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,-9 2.351141,-3.236068 8.5595086,-2.7811529 3.8042261,1.236068 5.2900673,7.2811529 0,4 -5.2900673,7.2811529 -3.8042261,1.236068 -8.5595086,-2.7811529 -2.351141,-3.236068 0,-9 ",
    id: "Star5"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 L 30240,0 L 30240,15120 L 0,15120 L 0,0 z",
    style: {
      fill: "#00008b"
    }
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(252,0,0,252,7560,11340)",
    id: "Commonwealth_Star",
    style: {
      fill: "#fff"
    },
    xlinkHref: "#Star7"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(120,0,0,120,22680,12600)",
    id: "Star_Alpha_Crucis",
    style: {
      fill: "#fff"
    },
    xlinkHref: "#Star7"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(120,0,0,120,18900,6615)",
    id: "Star_Beta_Crucis",
    style: {
      fill: "#fff"
    },
    xlinkHref: "#Star7"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(120,0,0,120,22680,2520)",
    id: "Star_Gamma_Crucis",
    style: {
      fill: "#fff"
    },
    xlinkHref: "#Star7"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(120,0,0,120,26040,5607)",
    id: "Star_Delta_Crucis",
    style: {
      fill: "#fff"
    },
    xlinkHref: "#Star7"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(70,0,0,70,24192,8190)",
    id: "Star_Epsilon_Crucis",
    style: {
      fill: "#fff"
    },
    xlinkHref: "#Star5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6300,0 L 8820,0 L 8820,2520 L 15120,2520 L 15120,5040 L 8820,5040 L 8820,7560 L 6300,7560 L 6300,5040 L 0,5040 L 0,2520 L 6300,2520 L 6300,0 z",
    id: "White_Cross",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 L 1690.4674,0 L 15120,6714.7663 L 15120,7560 L 13429.533,7560 L 0,845.2337 L 0,0 z",
    id: "White_Diagonal",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(-1,0,0,1,15120,0)",
    id: "White_Diagonal_Flipped",
    style: {
      fill: "#fff"
    },
    xlinkHref: "#White_Diagonal"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6804,0 L 8316,0 L 8316,3024 L 15120,3024 L 15120,4536 L 8316,4536 L 8316,7560 L 6804,7560 L 6804,4536 L 0,4536 L 0,3024 L 6804,3024 L 6804,0 z",
    id: "Red_Cross",
    style: {
      fill: "red"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 L 5040,2520 L 3913.0217,2520 L 0,563.48913 L 0,0 z M 15120,0 L 13993.022,0 L 8953.0217,2520 L 10080,2520 L 15120,0 z",
    id: "Red_Diagonals",
    style: {
      fill: "red"
    }
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(-1,0,0,-1,15120,7560)",
    id: "Red_Diagonals_Rotated",
    style: {
      fill: "red"
    },
    xlinkHref: "#Red_Diagonals"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAustralia);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };